import 'ion-rangeslider';
import * as $ from "jquery";
import Cookies from "js-cookie";
import {translator} from "./translator";

export const showPreloader = () => {
    $('body').css('overflow', 'hidden');
    $('#ticket_system_preloader').removeClass('ticket-system__hide');
}

export const hidePreloader = () => {
    $('body').css('overflow', 'auto');
    $('#ticket_system_preloader').addClass('ticket-system__hide');
}

export function isMobile() {
    return window.innerWidth < 1000;
}

export function isTablet() {
    return window.innerWidth > 760;
}

export function isDesktop() {
    return window.innerWidth > 1000;
}

export function findMinPrice(sectors) {

    let min = 999999;
    for (let i = 0; i < sectors.length; i++) {
        //убираем варианты, когда мин цена не пришла с сервера, равна 0 или пустой строке
        if (min > +sectors[i].minPrice && +sectors[i].minPrice && sectors[i].minPrice !== '0' && +sectors[i].minPrice !== 0) {

            min = sectors[i].minPrice;
        }
    }
    return Math.floor(min);
}

export function findMaxPrice(sectors) {
    let max = 0;
    for (let i = 0; i < sectors.length; i++) {
        if (max < +sectors[i].maxPrice && +sectors[i].maxPrice && sectors[i].maxPrice !== 0 && sectors[i].maxPrice !== '') {
            max = sectors[i].maxPrice;
        }
    }

    return Math.ceil(max);
}

/*init слайдеров: для десктоп - при изменении слайдера сразу фильтруем сектора, для мобильной - только при клике на "Применить"*/
export function initSliders(WIDGET_DATA, $domElements, cookieFlag) {

    $domElements.sliderMin.data('ticket-system__minPrice', WIDGET_DATA.minPrice);
    $domElements.sliderMax.data('ticket-system__maxPrice', WIDGET_DATA.maxPrice);

    $domElements.sliderMin.text(`${number_format(WIDGET_DATA.minPrice, 0, '', ' ')} ₽`);
    $domElements.sliderMax.text(`${number_format(WIDGET_DATA.maxPrice, 0, '', ' ')} ₽`);

    WIDGET_DATA.sliderFrom = WIDGET_DATA.minPrice;
    WIDGET_DATA.sliderTo = WIDGET_DATA.maxPrice;

    //если cookieFlag = true -> инициализируем с данными из куки
    if(cookieFlag){
        const currentCookieMinPrice = getCookie('currentMin');
        const currentCookieMaxPrice = getCookie('currentMax');

        WIDGET_DATA.sliderFrom = currentCookieMinPrice;
        WIDGET_DATA.sliderTo = currentCookieMaxPrice;

        $domElements.sliderMin.text(`${number_format( WIDGET_DATA.sliderFrom, 0, '', ' ')} ₽`);
        $domElements.sliderMax.text(`${number_format( WIDGET_DATA.sliderTo, 0, '', ' ')} ₽`);
    }

    $("#ticket-system__range-slider-desktop").ionRangeSlider({
        skin: 'round',
        type: "double",
        step: 100,
        min: WIDGET_DATA.minPrice,
        max: WIDGET_DATA.maxPrice,
        from:  WIDGET_DATA.sliderFrom,
        to: WIDGET_DATA.sliderTo,
        grid: false,
        hide_min_max: true,
        hide_from_to: true,
        onFinish: (data) => {
            setSliderData(data);

            $domElements.sliderMin.data('ticket-system__minPrice', data.from);
            $domElements.sliderMax.data('ticket-system__maxPrice', data.to);

            filterSectorsPrice(data.from, data.to, WIDGET_DATA);
            filterPlacesPrice(WIDGET_DATA);
        }
    });

    $("#ticket-system__range-slider-popup").ionRangeSlider({
        skin: 'round',
        type: "double",
        step: 100,
        min: WIDGET_DATA.minPrice,
        max: WIDGET_DATA.maxPrice,
        from: WIDGET_DATA.sliderFrom,
        to: WIDGET_DATA.sliderTo,
        grid: false,
        hide_min_max: true,
        hide_from_to: true,
        onFinish: (data) => {
            setSliderData(data);

            $domElements.sliderMin.data('ticket-system__minPrice', data.from);
            $domElements.sliderMax.data('ticket-system__maxPrice', data.to);
        }
    });

    function setSliderData(data) {
        WIDGET_DATA.sliderFrom = data.from;
        WIDGET_DATA.sliderTo = data.to;

        $domElements.sliderMin.text(`${data.from_pretty} ₽`);
        $domElements.sliderMax.text(`${data.to_pretty} ₽`);

        //сохраняем в куку мин/макс и текущее значение слайдера
        setCookie('minPrice', data.min);
        setCookie('maxPrice', data.max);
        setCookie('currentMin', data.from);
        setCookie('currentMax', data.to);
    }
}

/* Фильтрация секторов по ценам*/
export function filterSectorsPrice(currentMin, currentMax, WIDGET_DATA) {

    WIDGET_DATA.sectorSvgObjects.forEach(sector => {
        const freePlaces = sector.data('freePlaces');
        const sectorId = sector.data('id');
        const $textSectorSVG = $(`text[data-id="${sectorId}"]`);
        const sectorMinPrice = +sector.data('minPrice');
        const sectorMaxPrice = +sector.data('maxPrice');

        if (+freePlaces !== 0) {
            if (sectorMinPrice < currentMin && sectorMaxPrice < currentMin ||
                sectorMinPrice > currentMax && sectorMaxPrice > currentMax) {

                sectorUnavailable(sector, $textSectorSVG);

            } else {
                sectorAvailable(sector, $textSectorSVG);
            }
        }
    })

    function sectorUnavailable(sector, $textSectorSVG) {
        sector.animate({duration: 300, when: 'now'}).attr({fill: '#0b193b'});
        sector.animate({duration: 300, when: 'now'}).attr('stroke-width', WIDGET_DATA.drawingOptions.strokeWidth);
        sector.animate({duration: 300, when: 'now'}).attr('stroke', WIDGET_DATA.drawingOptions.strokeColor);
        sector.animate({duration: 300, when: 'now'}).attr('stroke-opacity', WIDGET_DATA.drawingOptions.strokeColor);
        $textSectorSVG.animate({duration: 300, when: 'now'}).attr({fill: 'white'});
    }

    function sectorAvailable(sector, $textSectorSVG) {
        const textDefaultColor = $textSectorSVG.data('color');

        sector.animate({duration: 300, when: 'now'}).attr({fill: `${sector.data('color')}`});
        sector.animate({duration: 300, when: 'now'}).attr('stroke-width', 0);
        $textSectorSVG.animate({duration: 300, when: 'now'}).attr({fill: `${textDefaultColor}`});
    }
}

export function filterPlacesPrice(WIDGET_DATA) {
    if (WIDGET_DATA.placesDOMElements.length === 0) {
        return;
    }
    //фильтрация мест на рендере
    WIDGET_DATA.placesDOMElements.forEach(place => {
        const $place = $(place);
        const isPlaceOnSale = $place.data('ticket__state');
        const placePrice = $place.data('ticket__prices');

        if (isPlaceOnSale) {
            if (+placePrice < WIDGET_DATA.sliderFrom || +placePrice > WIDGET_DATA.sliderTo) {
                $place.addClass('ticket-system__choose-places-soled-place');
                $place.data('ticket__is-in-price-bounds', '0');

            } else {
                $place.removeClass('ticket-system__choose-places-soled-place');
                $place.data('ticket__is-in-price-bounds', '1');
            }
        }
    })

    //фильтрация выбранных билетов
    if (WIDGET_DATA.chosenTickets.length !== 0) {
        WIDGET_DATA.chosenTickets.forEach(ticket => {
            const chosenTicketId = ticket.id;
            const $chosenTicket = $(`.ticket-system__choose-places-item[data-ticket__place-id="${chosenTicketId}"]`);
            const chosenTicketPrice = ticket.price;

            if (chosenTicketPrice < WIDGET_DATA.sliderFrom || chosenTicketPrice > WIDGET_DATA.sliderTo) {
                const $chosenTicketInPopup = $(`.ticket-system__popup-ticket[data-ticket__slide-id="${chosenTicketId}"]`);
                const $removeTicketBlock = $chosenTicketInPopup.find('.ticket-system__popup-ticket-right');

                //триггерим событие удаления в попапе выбранных билетов и
                // устанавливаем билету флаг, что он не в границах цен
                /*$removeTicketBlock.trigger('click');*/
                $chosenTicket.data('ticket__is-in-price-bounds', '0');

            } else {
                $chosenTicket.data('ticket__is-in-price-bounds', '1');
            }
        })
    }
}

//денежный формат
export function number_format(number, decimals, dec_point, thousands_sep) {
    let i, j, kw, kd, km;
    if (isNaN(decimals = Math.abs(decimals))) {
        decimals = 2;
    }
    if (dec_point == undefined) {
        dec_point = ',';
    }
    if (thousands_sep == undefined) {
        thousands_sep = '.';
    }
    i = parseInt(number = (+number || 0).toFixed(decimals)) + '';
    if ((j = i.length) > 3) {
        j = j % 3;
    } else {
        j = 0;
    }
    km = (j ? i.substr(0, j) + thousands_sep : '');
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands_sep);
    kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : '');
    return km + kw + kd;
}

//склонение
export function getRightTerm(number, one, two, five) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
        return five;
    }
    n %= 10;
    if (n === 1) {
        return one;
    }
    if (n >= 2 && n <= 4) {
        return two;
    }
    return five;
}

//фильтр по местам (пока что отключен)
export function filterPlaceNumbers(chosenPlaceValue = 0, dataPlaces) {
    //копируем объект с изначальными данными, для работы с копией
    let copyDataPlaces = JSON.parse(JSON.stringify(dataPlaces));

    switch (chosenPlaceValue) {
        case 0:
            return copyDataPlaces

        case 1:
            return copyDataPlaces

        case 2:
            for (let place in copyDataPlaces.places) {
                for (let i = 0; i < copyDataPlaces.places[place].length; i++) {

                    let currentPlace = copyDataPlaces.places[place][i];
                    let currentPlaceState = copyDataPlaces.places[place][i].state;

                    if (currentPlaceState === '0') continue;

                    if (copyDataPlaces.places[place][i + 1]?.state === '1' && copyDataPlaces.places[place][i - 1]?.state === '1') {
                        continue;

                    } else if (copyDataPlaces.places[place][i + 1]?.state === '0' && copyDataPlaces.places[place][i - 1]?.state === '0') {
                        currentPlace.state = '0';

                    } else if (i === 0 && copyDataPlaces.places[place][i + 1]?.state === '0') {
                        currentPlace.state = '0';

                    } else if (copyDataPlaces.places[place][i + 1]?.state === '0' && copyDataPlaces.places[place][i - 1]?.state === '1') {
                        continue;
                    }
                }
            }
            return copyDataPlaces

        case 3:
            for (let place in copyDataPlaces.places) {
                for (let i = 0; i < copyDataPlaces.places[place].length; i++) {

                    let currentPlaceState = copyDataPlaces.places[place][i].state;

                    if (currentPlaceState === '0') continue;

                    if (copyDataPlaces.places[place][i + 1]?.state === '1' && copyDataPlaces.places[place][i + 2]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i + 1]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '0' && copyDataPlaces.places[place][i + 1]?.state === '1'
                        && copyDataPlaces.places[place][i + 2]?.state === '0') {
                        copyDataPlaces.places[place][i].state = '0'
                        continue
                    }

                    copyDataPlaces.places[place][i].state = '0'
                }
            }
            return copyDataPlaces

        case 4:
            for (let place in copyDataPlaces.places) {
                for (let i = 0; i < copyDataPlaces.places[place].length; i++) {

                    let currentPlaceState = copyDataPlaces.places[place][i].state;

                    if (currentPlaceState === '0') continue;

                    if (copyDataPlaces.places[place][i + 1]?.state === '1' && copyDataPlaces.places[place][i + 2]?.state === '1'
                        && copyDataPlaces.places[place][i + 3]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i + 1]?.state === '1'
                        && copyDataPlaces.places[place][i + 2]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i + 1]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i - 3]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '0' && copyDataPlaces.places[place][i + 1]?.state === '1'
                        && copyDataPlaces.places[place][i + 2]?.state === '1' && copyDataPlaces.places[place][i + 3]?.state === '0') {
                        copyDataPlaces.places[place][i].state = '0'
                        continue

                    }

                    copyDataPlaces.places[place][i].state = '0'
                }
            }
            return copyDataPlaces

        case 5:
            for (let place in copyDataPlaces.places) {
                for (let i = 0; i < copyDataPlaces.places[place].length; i++) {

                    let currentPlaceState = copyDataPlaces.places[place][i].state;

                    if (currentPlaceState === '0') continue;

                    if (copyDataPlaces.places[place][i + 1]?.state === '1' && copyDataPlaces.places[place][i + 2]?.state === '1'
                        && copyDataPlaces.places[place][i + 3]?.state === '1' && copyDataPlaces.places[place][i + 4]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i + 1]?.state === '1'
                        && copyDataPlaces.places[place][i + 2]?.state === '1' && copyDataPlaces.places[place][i + 3]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i + 1]?.state === '1' && copyDataPlaces.places[place][i + 2]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i - 3]?.state === '1' && copyDataPlaces.places[place][i + 1]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i - 3]?.state === '1' && copyDataPlaces.places[place][i - 4]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '0' && copyDataPlaces.places[place][i + 1]?.state === '1'
                        && copyDataPlaces.places[place][i + 2]?.state === '1' && copyDataPlaces.places[place][i + 3]?.state === '0') {
                        copyDataPlaces.places[place][i].state = '0'
                        continue

                    }

                    copyDataPlaces.places[place][i].state = '0'
                }
            }
            return copyDataPlaces

        case 6:
            for (let place in copyDataPlaces.places) {
                for (let i = 0; i < copyDataPlaces.places[place].length; i++) {

                    let currentPlaceState = copyDataPlaces.places[place][i].state;

                    if (currentPlaceState === '0') continue;

                    if (copyDataPlaces.places[place][i + 1]?.state === '1' && copyDataPlaces.places[place][i + 2]?.state === '1'
                        && copyDataPlaces.places[place][i + 3]?.state === '1' && copyDataPlaces.places[place][i + 4]?.state === '1'
                        && copyDataPlaces.places[place][i + 5]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i + 1]?.state === '1'
                        && copyDataPlaces.places[place][i + 2]?.state === '1' && copyDataPlaces.places[place][i + 3]?.state === '1'
                        && copyDataPlaces.places[place][i + 4]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i + 1]?.state === '1' && copyDataPlaces.places[place][i + 2]?.state === '1'
                        && copyDataPlaces.places[place][i + 3]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i - 3]?.state === '1' && copyDataPlaces.places[place][i + 1]?.state === '1'
                        && copyDataPlaces.places[place][i + 2]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i - 3]?.state === '1' && copyDataPlaces.places[place][i - 4]?.state === '1'
                        && copyDataPlaces.places[place][i + 1]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '1' && copyDataPlaces.places[place][i - 2]?.state === '1'
                        && copyDataPlaces.places[place][i - 3]?.state === '1' && copyDataPlaces.places[place][i - 4]?.state === '1'
                        && copyDataPlaces.places[place][i - 5]?.state === '1') {
                        continue

                    } else if (copyDataPlaces.places[place][i - 1]?.state === '0' && copyDataPlaces.places[place][i + 1]?.state === '1'
                        && copyDataPlaces.places[place][i + 2]?.state === '1' && copyDataPlaces.places[place][i + 3]?.state === '0') {
                        copyDataPlaces.places[place][i].state = '0'
                        continue

                    }

                    copyDataPlaces.places[place][i].state = '0'
                }
            }
            return copyDataPlaces
    }

}

//проверка объекта на пустоту
export function isEmpty(obj) {
    for (let key in obj) {
        return false;
    }
    return true;
}

//проверка на NaN (для обычных секторов преобразованный id - всегда число, для статики (Пресса) и отключенных - NaN)
export function isNan(value) {
    return value !== value;
}

//проверка доступности секторов
export function checkSectorsAvailable(WIDGET_DATA) {

    //сектор b530 (id : 122188) и 12 (Металлург 19846) навсегда закостылен как "гостевой" (всегда выключен)
    //в случае, если есть гет-параметр custom_sector_access (доступ по ссылке), то включаем сектор, все остальные выключаем
    if(WIDGET_DATA.customSectorAccess && !WIDGET_DATA.isAbonement){
        handleCustomSectorAccess();
        return
    }

    WIDGET_DATA.sectorSvgObjects.forEach(sectorSvgObjectItem => {
        const sectorSvgObjectId = sectorSvgObjectItem.data('id');
        //проверка на наличие сектора в данных сервера
        if (!isSectorInDataFromServer(sectorSvgObjectId)) {
            makeSectorUnavailable(sectorSvgObjectId);

        } else {
            const sectorDataFromServer = WIDGET_DATA.sectors.find(sector => +sector.id === sectorSvgObjectId);
            //если сектор статический (Пресса и т.п.) - пропускаем и не задаём данные
            const isStatic = sectorSvgObjectItem.hasOwnProperty('isStatic');

            if (!isStatic) {
                const freePlaces = +sectorDataFromServer.freePlaces;
                const minSectorPrice = sectorDataFromServer.minPrice;
                const maxSectorPrice = sectorDataFromServer.maxPrice;

                const isSectorsPriceValid = +minSectorPrice !== 0 && minSectorPrice !== '' && +maxSectorPrice !== 0 && maxSectorPrice !== '';

                //если сектор есть в данных сервера,
                // но свободных мест 0
                // или отсутствует поле freePlaces,
                // или minPrice/maxPrice = 0 -> закрашиваем как проданный
                if (freePlaces === 0 || !sectorDataFromServer.hasOwnProperty('freePlaces') || !isSectorsPriceValid) {
                    makeSectorUnavailable(sectorSvgObjectId);
                    return
                }

                //сектор b530 (id : 122188) и 12 (Металлург 19846) навсегда закостылен как "гостевой" (всегда выключен)
                //в случае, если есть гет-параметр custom_sector_access (доступ по ссылке), то включаем сектор, все остальные выключаем
                if((+sectorSvgObjectId === 122188 || +sectorSvgObjectId === 19846) && !WIDGET_DATA.customSectorAccess){
                    makeSectorUnavailable(sectorSvgObjectId);
                    return;
                }

                sectorSvgObjectItem.data('freePlaces', freePlaces);
                sectorSvgObjectItem.data('minPrice', minSectorPrice);
                sectorSvgObjectItem.data('maxPrice', maxSectorPrice);
            }
        }
    })

    function isSectorInDataFromServer(sectorSvgObjectId) {
        //если сектор задан как отключенный -> отключаем
        if (WIDGET_DATA.disabledSectors.includes(sectorSvgObjectId)) {
            makeSectorUnavailable(sectorSvgObjectId);

            //если сектор включен и не статический -> возвращаем флаг о его наличии/отсутствии в данных с сервера
        } else {
            return WIDGET_DATA.sectors.filter(sector => +sector.id === sectorSvgObjectId).length > 0;
        }
    }

    function makeSectorUnavailable(sectorId) {
        const $unavailableSector = WIDGET_DATA.sectorSvgObjects.find(sectorSVG => sectorSVG.data('id') === sectorId);
        const $textNumberSVG = $(`text[data-id="${sectorId}"]`);

        $unavailableSector
            .fill(WIDGET_DATA.drawingOptions.colorDisabled)
            .stroke(WIDGET_DATA.drawingOptions.stroke)
            .data('freePlaces', '0');
        $textNumberSVG.attr({'fill': 'white'});
    }

    function handleCustomSectorAccess(){
        WIDGET_DATA.sectorSvgObjects.forEach(sectorSvgObjectItem => {
            const sectorSvgObjectId = sectorSvgObjectItem.data('id');

            console.log('first:', +sectorSvgObjectId !== 122188, 'second:',+sectorSvgObjectId !== 19846, 'third', +sectorSvgObjectId !== 122188 && +sectorSvgObjectId !== 19846, 'fourth', +sectorSvgObjectId !== 122188 || +sectorSvgObjectId !== 19846)

            if(+sectorSvgObjectId !== 122188 && +sectorSvgObjectId !== 19846){
                makeSectorUnavailable(sectorSvgObjectId);
                return
            }

            if (!isSectorInDataFromServer(sectorSvgObjectId)) {
                makeSectorUnavailable(sectorSvgObjectId);
                return
            }

            const sectorDataFromServer = WIDGET_DATA.sectors.find(sector => +sector.id === sectorSvgObjectId);

            const freePlaces = +sectorDataFromServer.freePlaces;
            const minSectorPrice = sectorDataFromServer.minPrice;
            const maxSectorPrice = sectorDataFromServer.maxPrice;

            const isSectorsPriceValid = +minSectorPrice !== 0 && minSectorPrice !== '' && +maxSectorPrice !== 0 && maxSectorPrice !== '';

            if (freePlaces === 0 || !sectorDataFromServer.hasOwnProperty('freePlaces') || !isSectorsPriceValid) {
                makeSectorUnavailable(sectorSvgObjectId);

            }else{
                sectorSvgObjectItem.data('freePlaces', freePlaces);
                sectorSvgObjectItem.data('minPrice', minSectorPrice);
                sectorSvgObjectItem.data('maxPrice', maxSectorPrice);
            }
        });
    }
}

//скрытие/показ блоков в зависимости от хеша
export function renderRoute(route, $domElements, WIDGET_DATA) {
    switch (route) {
        case 'choose_sector':
            $domElements.returnBlock.hide();
            $domElements.headerMatchInfo.show();
            $domElements.filterDesktop.find('.ticket-system__slider-wrapper').show();
            $domElements.body.find('.ticket-system___deadline-timer').hide();

            //сначала скрываем попап, затем удаляем класс, чтобы не было анимации
            $domElements.popupTickets.hide();
            $domElements.popupTickets.removeClass('ticket-system__popup-tickets-active');

            //устанавливаем заголовок в случае возврата с Выбора места
            $domElements.contentTitle.html(translator('Выберите сектор',WIDGET_DATA.lang));
            $domElements.contentTitle.removeClass('content-title-order-info');
            //при возврате с заказа на выбор места - меняем общую тему
            $domElements.mainBlock.removeClass('ticket-system__order-info-main');
            $domElements.mainBlock.removeClass('ticket-system__submit-order-theme');

            scrollToTop();
            break;

        case 'choose_place':
            //при переходе на выбор места - сразу скрываем попап и триггерим закрытие для сброса выбранного сектора
            $domElements.popupChooseSector.removeClass('ticket-system__popup-show ticket-system__popup-show-effect')
            $domElements.body.find('[data-close-choose-sector-popup]').click();
            $domElements.returnBlock.show();
            $domElements.filterDesktop.find('.ticket-system__slider-wrapper').show();

            //если есть инстанс таймера - показываем его
            if(WIDGET_DATA.deadlineTimerInstance){
                $domElements.body.find('.ticket-system___deadline-timer').show();
            }

            $domElements.popupTickets.show();
            $domElements.headerMatchInfo.hide();
            //при возврате с заказа на выбор места - меняем общую тему
            $domElements.mainBlock.removeClass('ticket-system__order-info-main');

            //меняем заголовок контента
            //если самараАрена (23) - один заголовок, для металла (19) - другой
            if(WIDGET_DATA.arenaId === '23'){
                const isCostil = WIDGET_DATA.matchId === 3290 && WIDGET_DATA.chosenSector.name.toLowerCase() === 'b530';

                $domElements.contentTitle.html(`<span style="white-space: normal; word-break: break-word">${isCostil ? `${translator('СЕКТОР ЦСКА',WIDGET_DATA.lang)}, `: ''} </span> ${isCostil ? translator('Сектор',WIDGET_DATA.lang).toLowerCase() : translator('Сектор',WIDGET_DATA.lang)} <span 
                style="text-transform: uppercase;">${WIDGET_DATA.chosenSector.name[0]}</span>,
                 ${translator('блок',WIDGET_DATA.lang)} <span style="text-transform: uppercase;color: ${WIDGET_DATA.chosenSector.color}">${WIDGET_DATA.chosenSector.name}</span>`);

            }else if(WIDGET_DATA.arenaId === '19'){
                $domElements.contentTitle.html(`${translator('Сектор',WIDGET_DATA.lang)} <span 
                style="text-transform: uppercase;">${WIDGET_DATA.chosenSector.name}</span>`);
            }

            $domElements.contentTitle.removeClass('content-title-order-info');
            $domElements.mainBlock.removeClass('ticket-system__submit-order-theme');
            scrollToTop();
            break;

        case 'order_info':
            //меняем заголовок контента
            let ticketsPrice = 0;
            WIDGET_DATA.chosenTickets.forEach(ticket => {
                ticketsPrice += +ticket.price;
            });

            $domElements.contentTitle.addClass('content-title-order-info');

            //если нет ни улуг, ни паркинга и это абонементы - скрываем сумму на странице инф о заказе
            let ticketsSumBlock = '';

            if(WIDGET_DATA.serviceProducts.length && WIDGET_DATA.parkingProducts.length){
                ticketsSumBlock = `  <div class="ticket-system__order-info-tickets-price">
                        <span class="ticket-system__order-info-decorate-text">Cумма</span>
                        <span class="ticket-system__order-info-tickets-price-value" data-ticket-system__order-info-tickets-price-value="${ticketsPrice}">${getRightPrice(ticketsPrice)} ₽</span>
                    </div>`
            }

            //для абонементов другой текст
            //TODO
            /*if(WIDGET_DATA.isAbonement){
                $domElements.contentTitle.html(`
                    <div class="ticket-system__rolling-icon" data-ticket-system-roll-type="1">Абонементы</div>
                    ${ticketsSumBlock}
                `);

            }else{
                $domElements.contentTitle.html(`
                    <div class="ticket-system__rolling-icon" data-ticket-system-roll-type="1">Билеты</div>
                    ${ticketsSumBlock}
                `);
            }*/

            $domElements.contentTitle.html(`Корзина`);

            $domElements.popupTickets.hide();
            $domElements.filterDesktop.find('.ticket-system__slider-wrapper').hide();
            $domElements.returnBlock.show();
            //при переходе на Информацию о заказе - меняем тему
            $domElements.mainBlock.addClass('ticket-system__order-info-main');
            $domElements.mainBlock.removeClass('ticket-system__submit-order-theme');
            scrollToTop();
            break;

        case 'submit_order':
            $domElements.popupTickets.hide();
            $domElements.filterDesktop.find('.ticket-system__slider-wrapper').hide();
            $domElements.returnBlock.show();

            $domElements.contentTitle.html(`<span>${translator('Оформление заказа',WIDGET_DATA.lang)}</span>`);
            //при переходе на Информацию о заказе - меняем тему
            $domElements.mainBlock.removeClass('ticket-system__order-info-main');
            $domElements.mainBlock.addClass('ticket-system__submit-order-theme');

            //если есть промокод
            if(WIDGET_DATA.promocodeData.min_value &&
                WIDGET_DATA.promocodeData.min_value <= WIDGET_DATA.orderFullPrice &&
                WIDGET_DATA.promocodeData.discount_value &&
                WIDGET_DATA.isPromocodesAvailable){

            }

            scrollToTop();
            break;

        case 'tickets_page':
            //если есть почта
            if(WIDGET_DATA.emailFromSendPaymentStatus !== ''){
                $('#email_for_sending_ticket').val(WIDGET_DATA.emailFromSendPaymentStatus);
                $('#email_for_sending_ticket').parents('.field').removeClass('empty').addClass('success');
            }
            //показываем билеты
            $domElements.ticketsPage.css('display', 'flex');
            $domElements.errorPage.css('display', 'none');
            break;

        case 'error_page':
            hidePreloader();
            //показываем страницу ошибки
            $domElements.ticketsPage.css('display', 'none');
            $domElements.errorPage.css('display', 'flex');
            break;

        default:
            break;
    }
}

//проверка на корректность пришедших с сервера данных
export function isDataCorrect(data) {
    return data && data?.resultCode === '200' && data?.payload?.status === 'success' && !isEmpty(data);
}

//скролл к верхнему краю хедера билетного виджета
export function scrollToTop(){
    if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){
        $('html').scrollTop(0) || $('body').scrollTop(0);

    }else{
        $('html').scrollTop(0);
    }
}

//ковидный баннер
export function initCovidHandler($domElements, covidFlag) {
    if (covidFlag !== 1) return;

    setTimeout(() => {
        $domElements.covidBanner.addClass('ticket-system__covid-show');
    }, 5);

    $domElements.covidBanner.on('click', () => {
        $domElements.covidBanner.removeClass('ticket-system__covid-show');
        setTimeout(() => {
            $domElements.covidBanner.remove();
        }, 300)
    })
}


export function validateMobilePhone(value) {
    const mobilePhoneInvalidFirstSymbols = ['0', '1', '2', '7']
    const regNum = /^\d+$/

    const clearValue = getClearMaskedValue(value)

    if (!clearValue || clearValue.length !== 10) {
        return false
    }

    if (clearValue.search(regNum) === -1) {
        return false
    }

    return !mobilePhoneInvalidFirstSymbols.includes(clearValue[0])


}

export function validateEmail(value) {
    if (!value) { return false }

    const regEmail = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,}$/i
    if (value.search(regEmail) === -1) {
        return false
    }

    return true
}

export function validateDualInput(input, mask){
    const $input = $(input);

    if($input.val().length === 0){
        $input.siblings('.error-message').text('Поле обязательно для заполнения');
        $input.parent('.field').addClass('error');
        $input.parent('.field').removeClass('success');
        return false;
    }

    if (mask === 'phone') {
        if (validateMobilePhone($input.val())) {
            $input.siblings('.error-message').text('');
            $input.parent('.field').removeClass('error');
            $input.parent('.field').addClass('success');
            return true;

        } else {
            $input.siblings('.error-message').text('Укажите корректный номер телефона');
            $input.parent('.field').addClass('error');
            $input.parent('.field').removeClass('success');
            return false;
        }
    }else if(mask === 'email'){
        if (validateEmail($input.val())) {
            $input.siblings('.error-message').text('');
            $input.parent('.field').removeClass('error');
            $input.parent('.field').addClass('success');
            return true;

        } else {
            $input.siblings('.error-message').text('Укажите корректный адрес электронной почты');
            $input.parent('.field').addClass('error');
            $input.parent('.field').removeClass('success');
            return false;
        }
    }
}

export function getClearMaskedValue(value) {
    if (!value) { return '' }
    if (typeof value === 'number') value = String(value)
    let result = value

    result = result.replace(/[\s()-]/g, '');
    result = result.replace('+7', '');

    return result
}

//вспомогательная функция для манипуляции с сайтом
export function editSite(WIDGET_DATA){
    $('body').find('ul.partners.reset-list').parents('section.section').addClass('no-padding-mobile');

    //партнеры
    if(WIDGET_DATA.isAbonement){
        $('#partner_swiper').parents('section').hide();
    }

    //отсутп для футера
    $('footer').css('margin-top', 'auto');
}

//проверка на доступность выбранных мест в куке
export function checkAvailabilityCookiePlaces(places){
    //выбранные места в куке
    const cookiePlaces = getCookie('chosen_tickets');
    let result = true;

    cookiePlaces.forEach(cookiePlace => {
        const cookiePlaceId = cookiePlace.id;
        const placeFromServer = places.find(place => +place.id === cookiePlaceId);

        //если места нет или оно недоступно в местах с сервера -> возвращаем false
        if(!placeFromServer || !placeFromServer.isAvailable){
            result = false;
        }
    });

    return result;
}


//проверка на доступность купленного ранее абонемента на доступность
export function checkAvailabilityOldAbonementPlace(places, oldAbonementId){
    let result;

    result = places.find(place => +place.id === +oldAbonementId);

    if(!result || !result.isAvailable){
        result = false;
    }

    return result;
}

//сохраняем текущее состояние по ключу в куку (выбранный сектор, места)
export function setCookie(key, value){
    Cookies.set(key, JSON.stringify(value));
}

//получаем текущее состояние по ключу в куке (выбранный сектор, места)
export function getCookie(key){
    //проверяем, что кука есть
    if(typeof Cookies.get(key) === 'undefined'){
        return false;
    }

    return JSON.parse(Cookies.get(key));
}

//получение стоимости в независимости - целое ли число или десятичное
export function getRightPrice(price){
    //если число целое - возвращаем без разделителей
    if(Number.isInteger(price)){
        return number_format(price,'','',' ' );

        //иначе - с копейками
    }else{
        return number_format(price,2,',',' ' );
    }
}
